import { styled } from '@mui/material/styles';

const StyledFormSettingsPreview = styled('div')`
  border: 1px solid #d1d5db;
  width: 364px;
  height: 768px;
  padding: 24px;
  position: relative;
  box-sizing: border-box;
  border-radius: 4px;
  align-self: center;

  & > h3 {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 24px;
    line-height: 1.2;
  }
`;

export default StyledFormSettingsPreview;
